import { Tree as A, NodeProp as y, NodeType as Q, IterMode as Ae, TreeFragment as M, Parser as Te } from "./ghl-ui.es425.js";
import { StateField as X, Facet as w, EditorState as O, RangeSet as Pe, Prec as De, StateEffect as H, countColumn as Oe, combineConfig as se, RangeSetBuilder as le } from "./ghl-ui.es268.js";
import { EditorView as b, ViewPlugin as Y, gutter as Be, logException as Ie, Decoration as g, WidgetType as ae, GutterMarker as Me } from "./ghl-ui.es269.js";
import { tags as u, styleTags as Ne, tagHighlighter as Ee, highlightTree as Fe } from "./ghl-ui.es768.js";
import { StyleModule as ee } from "./ghl-ui.es433.js";
var R;
const T = /* @__PURE__ */ new y();
function He(n) {
  return w.define({
    combine: n ? (e) => e.concat(n) : void 0
  });
}
const Le = /* @__PURE__ */ new y();
class m {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(e, t, r = [], i = "") {
    this.data = e, this.name = i, O.prototype.hasOwnProperty("tree") || Object.defineProperty(O.prototype, "tree", { get() {
      return k(this);
    } }), this.parser = t, this.extension = [
      v.of(this),
      O.languageData.of((s, o, a) => {
        let l = te(s, o, a), c = l.type.prop(T);
        if (!c)
          return [];
        let f = s.facet(c), h = l.type.prop(Le);
        if (h) {
          let p = l.resolve(o - l.from, a);
          for (let d of h)
            if (d.test(p, s)) {
              let S = s.facet(d.facet);
              return d.type == "replace" ? S : S.concat(f);
            }
        }
        return f;
      })
    ].concat(r);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(e, t, r = -1) {
    return te(e, t, r).type.prop(T) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(e) {
    let t = e.facet(v);
    if ((t == null ? void 0 : t.data) == this.data)
      return [{ from: 0, to: e.doc.length }];
    if (!t || !t.allowsNesting)
      return [];
    let r = [], i = (s, o) => {
      if (s.prop(T) == this.data) {
        r.push({ from: o, to: o + s.length });
        return;
      }
      let a = s.prop(y.mounted);
      if (a) {
        if (a.tree.prop(T) == this.data) {
          if (a.overlay)
            for (let l of a.overlay)
              r.push({ from: l.from + o, to: l.to + o });
          else
            r.push({ from: o, to: o + s.length });
          return;
        } else if (a.overlay) {
          let l = r.length;
          if (i(a.tree, a.overlay[0].from + o), r.length > l)
            return;
        }
      }
      for (let l = 0; l < s.children.length; l++) {
        let c = s.children[l];
        c instanceof A && i(c, s.positions[l] + o);
      }
    };
    return i(k(e), 0), r;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return !0;
  }
}
m.setState = /* @__PURE__ */ H.define();
function te(n, e, t) {
  let r = n.facet(v), i = k(n).topNode;
  if (!r || r.allowsNesting)
    for (let s = i; s; s = s.enter(e, t, Ae.ExcludeBuffers))
      s.type.isTop && (i = s);
  return i;
}
class G extends m {
  constructor(e, t, r) {
    super(e, t, [], r), this.parser = t;
  }
  /**
  Define a language from a parser.
  */
  static define(e) {
    let t = He(e.languageData);
    return new G(t, e.parser.configure({
      props: [T.add((r) => r.isTop ? t : void 0)]
    }), e.name);
  }
  /**
  Create a new instance of this language with a reconfigured
  version of its parser and optionally a new name.
  */
  configure(e, t) {
    return new G(this.data, this.parser.configure(e), t || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function k(n) {
  let e = n.field(m.state, !1);
  return e ? e.tree : A.empty;
}
class We {
  /**
  Create an input object for the given document.
  */
  constructor(e) {
    this.doc = e, this.cursorPos = 0, this.string = "", this.cursor = e.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(e) {
    return this.string = this.cursor.next(e - this.cursorPos).value, this.cursorPos = e + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(e) {
    return this.syncTo(e), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(e, t) {
    let r = this.cursorPos - this.string.length;
    return e < r || t >= this.cursorPos ? this.doc.sliceString(e, t) : this.string.slice(e - r, t - r);
  }
}
let D = null;
class N {
  constructor(e, t, r = [], i, s, o, a, l) {
    this.parser = e, this.state = t, this.fragments = r, this.tree = i, this.treeLen = s, this.viewport = o, this.skipped = a, this.scheduleOn = l, this.parse = null, this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(e, t, r) {
    return new N(e, t, [], A.empty, 0, r, [], null);
  }
  startParse() {
    return this.parser.startParse(new We(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(e, t) {
    return t != null && t >= this.state.doc.length && (t = void 0), this.tree != A.empty && this.isDone(t ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var r;
      if (typeof e == "number") {
        let i = Date.now() + e;
        e = () => Date.now() > i;
      }
      for (this.parse || (this.parse = this.startParse()), t != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > t) && t < this.state.doc.length && this.parse.stopAt(t); ; ) {
        let i = this.parse.advance();
        if (i)
          if (this.fragments = this.withoutTempSkipped(M.addTree(i, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (r = this.parse.stoppedAt) !== null && r !== void 0 ? r : this.state.doc.length, this.tree = i, this.parse = null, this.treeLen < (t ?? this.state.doc.length))
            this.parse = this.startParse();
          else
            return !0;
        if (e())
          return !1;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let e, t;
    this.parse && (e = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > e) && this.parse.stopAt(e), this.withContext(() => {
      for (; !(t = this.parse.advance()); )
        ;
    }), this.treeLen = e, this.tree = t, this.fragments = this.withoutTempSkipped(M.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(e) {
    let t = D;
    D = this;
    try {
      return e();
    } finally {
      D = t;
    }
  }
  withoutTempSkipped(e) {
    for (let t; t = this.tempSkipped.pop(); )
      e = ne(e, t.from, t.to);
    return e;
  }
  /**
  @internal
  */
  changes(e, t) {
    let { fragments: r, tree: i, treeLen: s, viewport: o, skipped: a } = this;
    if (this.takeTree(), !e.empty) {
      let l = [];
      if (e.iterChangedRanges((c, f, h, p) => l.push({ fromA: c, toA: f, fromB: h, toB: p })), r = M.applyChanges(r, l), i = A.empty, s = 0, o = { from: e.mapPos(o.from, -1), to: e.mapPos(o.to, 1) }, this.skipped.length) {
        a = [];
        for (let c of this.skipped) {
          let f = e.mapPos(c.from, 1), h = e.mapPos(c.to, -1);
          f < h && a.push({ from: f, to: h });
        }
      }
    }
    return new N(this.parser, t, r, i, s, o, a, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(e) {
    if (this.viewport.from == e.from && this.viewport.to == e.to)
      return !1;
    this.viewport = e;
    let t = this.skipped.length;
    for (let r = 0; r < this.skipped.length; r++) {
      let { from: i, to: s } = this.skipped[r];
      i < e.to && s > e.from && (this.fragments = ne(this.fragments, i, s), this.skipped.splice(r--, 1));
    }
    return this.skipped.length >= t ? !1 : (this.reset(), !0);
  }
  /**
  @internal
  */
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(e, t) {
    this.skipped.push({ from: e, to: t });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(e) {
    return new class extends Te {
      createParse(t, r, i) {
        let s = i[0].from, o = i[i.length - 1].to;
        return {
          parsedPos: s,
          advance() {
            let l = D;
            if (l) {
              for (let c of i)
                l.tempSkipped.push(c);
              e && (l.scheduleOn = l.scheduleOn ? Promise.all([l.scheduleOn, e]) : e);
            }
            return this.parsedPos = o, new A(Q.none, [], [], o - s);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  /**
  @internal
  */
  isDone(e) {
    e = Math.min(e, this.state.doc.length);
    let t = this.fragments;
    return this.treeLen >= e && t.length && t[0].from == 0 && t[0].to >= e;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return D;
  }
}
function ne(n, e, t) {
  return M.applyChanges(n, [{ fromA: e, toA: t, fromB: e, toB: t }]);
}
class P {
  constructor(e) {
    this.context = e, this.tree = e.tree;
  }
  apply(e) {
    if (!e.docChanged && this.tree == this.context.tree)
      return this;
    let t = this.context.changes(e.changes, e.state), r = this.context.treeLen == e.startState.doc.length ? void 0 : Math.max(e.changes.mapPos(this.context.treeLen), t.viewport.to);
    return t.work(20, r) || t.takeTree(), new P(t);
  }
  static init(e) {
    let t = Math.min(3e3, e.doc.length), r = N.create(e.facet(v).parser, e, { from: 0, to: t });
    return r.work(20, t) || r.takeTree(), new P(r);
  }
}
m.state = /* @__PURE__ */ X.define({
  create: P.init,
  update(n, e) {
    for (let t of e.effects)
      if (t.is(m.setState))
        return t.value;
    return e.startState.facet(v) != e.state.facet(v) ? P.init(e.state) : n.apply(e);
  }
});
let fe = (n) => {
  let e = setTimeout(
    () => n(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(e);
};
typeof requestIdleCallback < "u" && (fe = (n) => {
  let e = -1, t = setTimeout(
    () => {
      e = requestIdleCallback(n, {
        timeout: 500 - 100
        /* Work.MinPause */
      });
    },
    100
    /* Work.MinPause */
  );
  return () => e < 0 ? clearTimeout(t) : cancelIdleCallback(e);
});
const $ = typeof navigator < "u" && (!((R = navigator.scheduling) === null || R === void 0) && R.isInputPending) ? () => navigator.scheduling.isInputPending() : null, Ue = /* @__PURE__ */ Y.fromClass(class {
  constructor(e) {
    this.view = e, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(e) {
    let t = this.view.state.field(m.state).context;
    (t.updateViewport(e.view.viewport) || this.view.viewport.to > t.treeLen) && this.scheduleWork(), (e.docChanged || e.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(t);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: e } = this.view, t = e.field(m.state);
    (t.tree != t.context.tree || !t.context.isDone(e.doc.length)) && (this.working = fe(this.work));
  }
  work(e) {
    this.working = null;
    let t = Date.now();
    if (this.chunkEnd < t && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = t + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: r, viewport: { to: i } } = this.view, s = r.field(m.state);
    if (s.tree == s.context.tree && s.context.isDone(
      i + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let o = Date.now() + Math.min(this.chunkBudget, 100, e && !$ ? Math.max(25, e.timeRemaining() - 5) : 1e9), a = s.context.treeLen < i && r.doc.length > i + 1e3, l = s.context.work(() => $ && $() || Date.now() > o, i + (a ? 0 : 1e5));
    this.chunkBudget -= Date.now() - t, (l || this.chunkBudget <= 0) && (s.context.takeTree(), this.view.dispatch({ effects: m.setState.of(new P(s.context)) })), this.chunkBudget > 0 && !(l && !a) && this.scheduleWork(), this.checkAsyncSchedule(s.context);
  }
  checkAsyncSchedule(e) {
    e.scheduleOn && (this.workScheduled++, e.scheduleOn.then(() => this.scheduleWork()).catch((t) => Ie(this.view.state, t)).then(() => this.workScheduled--), e.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), v = /* @__PURE__ */ w.define({
  combine(n) {
    return n.length ? n[0] : null;
  },
  enables: (n) => [
    m.state,
    Ue,
    b.contentAttributes.compute([n], (e) => {
      let t = e.facet(n);
      return t && t.name ? { "data-language": t.name } : {};
    })
  ]
});
class It {
  /**
  Create a language support object.
  */
  constructor(e, t = []) {
    this.language = e, this.support = t, this.extension = [e, t];
  }
}
const Re = /* @__PURE__ */ w.define(), ce = /* @__PURE__ */ w.define({
  combine: (n) => {
    if (!n.length)
      return "  ";
    let e = n[0];
    if (!e || /\S/.test(e) || Array.from(e).some((t) => t != e[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(n[0]));
    return e;
  }
});
function $e(n) {
  let e = n.facet(ce);
  return e.charCodeAt(0) == 9 ? n.tabSize * e.length : e.length;
}
function je(n, e) {
  let t = "", r = n.tabSize, i = n.facet(ce)[0];
  if (i == "	") {
    for (; e >= r; )
      t += "	", e -= r;
    i = " ";
  }
  for (let s = 0; s < e; s++)
    t += i;
  return t;
}
function qe(n, e) {
  n instanceof O && (n = new ue(n));
  for (let r of n.state.facet(Re)) {
    let i = r(n, e);
    if (i !== void 0)
      return i;
  }
  let t = k(n.state);
  return t.length >= e ? Ge(n, t, e) : null;
}
class ue {
  /**
  Create an indent context.
  */
  constructor(e, t = {}) {
    this.state = e, this.options = t, this.unit = $e(e);
  }
  /**
  Get a description of the line at the given position, taking
  [simulated line
  breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  into account. If there is such a break at `pos`, the `bias`
  argument determines whether the part of the line line before or
  after the break is used.
  */
  lineAt(e, t = 1) {
    let r = this.state.doc.lineAt(e), { simulateBreak: i, simulateDoubleBreak: s } = this.options;
    return i != null && i >= r.from && i <= r.to ? s && i == e ? { text: "", from: e } : (t < 0 ? i < e : i <= e) ? { text: r.text.slice(i - r.from), from: i } : { text: r.text.slice(0, i - r.from), from: r.from } : r;
  }
  /**
  Get the text directly after `pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  textAfterPos(e, t = 1) {
    if (this.options.simulateDoubleBreak && e == this.options.simulateBreak)
      return "";
    let { text: r, from: i } = this.lineAt(e, t);
    return r.slice(e - i, Math.min(r.length, e + 100 - i));
  }
  /**
  Find the column for the given position.
  */
  column(e, t = 1) {
    let { text: r, from: i } = this.lineAt(e, t), s = this.countColumn(r, e - i), o = this.options.overrideIndentation ? this.options.overrideIndentation(i) : -1;
    return o > -1 && (s += o - this.countColumn(r, r.search(/\S|$/))), s;
  }
  /**
  Find the column position (taking tabs into account) of the given
  position in the given string.
  */
  countColumn(e, t = e.length) {
    return Oe(e, this.state.tabSize, t);
  }
  /**
  Find the indentation column of the line at the given point.
  */
  lineIndent(e, t = 1) {
    let { text: r, from: i } = this.lineAt(e, t), s = this.options.overrideIndentation;
    if (s) {
      let o = s(i);
      if (o > -1)
        return o;
    }
    return this.countColumn(r, r.search(/\S|$/));
  }
  /**
  Returns the [simulated line
  break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  for this context, if any.
  */
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const ze = /* @__PURE__ */ new y();
function Ge(n, e, t) {
  let r = e.resolveStack(t), i = r.node.enterUnfinishedNodesBefore(t);
  if (i != r.node) {
    let s = [];
    for (let o = i; o != r.node; o = o.parent)
      s.push(o);
    for (let o = s.length - 1; o >= 0; o--)
      r = { node: s[o], next: r };
  }
  return he(r, n, t);
}
function he(n, e, t) {
  for (let r = n; r; r = r.next) {
    let i = Ve(r.node);
    if (i)
      return i(Z.create(e, t, r));
  }
  return 0;
}
function Je(n) {
  return n.pos == n.options.simulateBreak && n.options.simulateDoubleBreak;
}
function Ve(n) {
  let e = n.type.prop(ze);
  if (e)
    return e;
  let t = n.firstChild, r;
  if (t && (r = t.type.prop(y.closedBy))) {
    let i = n.lastChild, s = i && r.indexOf(i.name) > -1;
    return (o) => de(o, !0, 1, void 0, s && !Je(o) ? i.from : void 0);
  }
  return n.parent == null ? Ke : null;
}
function Ke() {
  return 0;
}
class Z extends ue {
  constructor(e, t, r) {
    super(e.state, e.options), this.base = e, this.pos = t, this.context = r;
  }
  /**
  The syntax tree node to which the indentation strategy
  applies.
  */
  get node() {
    return this.context.node;
  }
  /**
  @internal
  */
  static create(e, t, r) {
    return new Z(e, t, r);
  }
  /**
  Get the text directly after `this.pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  /**
  Get the indentation at the reference line for `this.node`, which
  is the line on which it starts, unless there is a node that is
  _not_ a parent of this node covering the start of that line. If
  so, the line at the start of that node is tried, again skipping
  on if it is covered by another such node.
  */
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  /**
  Get the indentation for the reference line of the given node
  (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
  */
  baseIndentFor(e) {
    let t = this.state.doc.lineAt(e.from);
    for (; ; ) {
      let r = e.resolve(t.from);
      for (; r.parent && r.parent.from == r.from; )
        r = r.parent;
      if (Qe(r, e))
        break;
      t = this.state.doc.lineAt(r.from);
    }
    return this.lineIndent(t.from);
  }
  /**
  Continue looking for indentations in the node's parent nodes,
  and return the result of that.
  */
  continue() {
    return he(this.context.next, this.base, this.pos);
  }
}
function Qe(n, e) {
  for (let t = e; t; t = t.parent)
    if (n == t)
      return !0;
  return !1;
}
function Xe(n) {
  let e = n.node, t = e.childAfter(e.from), r = e.lastChild;
  if (!t)
    return null;
  let i = n.options.simulateBreak, s = n.state.doc.lineAt(t.from), o = i == null || i <= s.from ? s.to : Math.min(s.to, i);
  for (let a = t.to; ; ) {
    let l = e.childAfter(a);
    if (!l || l == r)
      return null;
    if (!l.type.isSkipped)
      return l.from < o ? t : null;
    a = l.to;
  }
}
function Mt({ closing: n, align: e = !0, units: t = 1 }) {
  return (r) => de(r, e, t, n);
}
function de(n, e, t, r, i) {
  let s = n.textAfter, o = s.match(/^\s*/)[0].length, a = r && s.slice(o, o + r.length) == r || i == n.pos + o, l = e ? Xe(n) : null;
  return l ? a ? n.column(l.from) : n.column(l.to) : n.baseIndent + (a ? 0 : n.unit * t);
}
const Nt = (n) => n.baseIndent;
function Et({ except: n, units: e = 1 } = {}) {
  return (t) => {
    let r = n && n.test(t.textAfter);
    return t.baseIndent + (r ? 0 : e * t.unit);
  };
}
const Ye = 200;
function Ft() {
  return O.transactionFilter.of((n) => {
    if (!n.docChanged || !n.isUserEvent("input.type") && !n.isUserEvent("input.complete"))
      return n;
    let e = n.startState.languageDataAt("indentOnInput", n.startState.selection.main.head);
    if (!e.length)
      return n;
    let t = n.newDoc, { head: r } = n.newSelection.main, i = t.lineAt(r);
    if (r > i.from + Ye)
      return n;
    let s = t.sliceString(i.from, r);
    if (!e.some((c) => c.test(s)))
      return n;
    let { state: o } = n, a = -1, l = [];
    for (let { head: c } of o.selection.ranges) {
      let f = o.doc.lineAt(c);
      if (f.from == a)
        continue;
      a = f.from;
      let h = qe(o, f.from);
      if (h == null)
        continue;
      let p = /^\s*/.exec(f.text)[0], d = je(o, h);
      p != d && l.push({ from: f.from, to: f.from + p.length, insert: d });
    }
    return l.length ? [n, { changes: l, sequential: !0 }] : n;
  });
}
const Ze = /* @__PURE__ */ w.define(), _e = /* @__PURE__ */ new y();
function Ht(n) {
  let e = n.firstChild, t = n.lastChild;
  return e && e.to < t.from ? { from: e.to, to: t.type.isError ? n.to : t.from } : null;
}
function et(n, e, t) {
  let r = k(n);
  if (r.length < t)
    return null;
  let i = r.resolveStack(t, 1), s = null;
  for (let o = i; o; o = o.next) {
    let a = o.node;
    if (a.to <= t || a.from > t)
      continue;
    if (s && a.from < e)
      break;
    let l = a.type.prop(_e);
    if (l && (a.to < r.length - 50 || r.length == n.doc.length || !tt(a))) {
      let c = l(a, n);
      c && c.from <= t && c.from >= e && c.to > t && (s = c);
    }
  }
  return s;
}
function tt(n) {
  let e = n.lastChild;
  return e && e.to == n.to && e.type.isError;
}
function E(n, e, t) {
  for (let r of n.facet(Ze)) {
    let i = r(n, e, t);
    if (i)
      return i;
  }
  return et(n, e, t);
}
function pe(n, e) {
  let t = e.mapPos(n.from, 1), r = e.mapPos(n.to, -1);
  return t >= r ? void 0 : { from: t, to: r };
}
const L = /* @__PURE__ */ H.define({ map: pe }), B = /* @__PURE__ */ H.define({ map: pe });
function me(n) {
  let e = [];
  for (let { head: t } of n.state.selection.ranges)
    e.some((r) => r.from <= t && r.to >= t) || e.push(n.lineBlockAt(t));
  return e;
}
const x = /* @__PURE__ */ X.define({
  create() {
    return g.none;
  },
  update(n, e) {
    n = n.map(e.changes);
    for (let t of e.effects)
      if (t.is(L) && !nt(n, t.value.from, t.value.to)) {
        let { preparePlaceholder: r } = e.state.facet(_), i = r ? g.replace({ widget: new at(r(e.state, t.value)) }) : re;
        n = n.update({ add: [i.range(t.value.from, t.value.to)] });
      } else
        t.is(B) && (n = n.update({
          filter: (r, i) => t.value.from != r || t.value.to != i,
          filterFrom: t.value.from,
          filterTo: t.value.to
        }));
    if (e.selection) {
      let t = !1, { head: r } = e.selection.main;
      n.between(r, r, (i, s) => {
        i < r && s > r && (t = !0);
      }), t && (n = n.update({
        filterFrom: r,
        filterTo: r,
        filter: (i, s) => s <= r || i >= r
      }));
    }
    return n;
  },
  provide: (n) => b.decorations.from(n),
  toJSON(n, e) {
    let t = [];
    return n.between(0, e.doc.length, (r, i) => {
      t.push(r, i);
    }), t;
  },
  fromJSON(n) {
    if (!Array.isArray(n) || n.length % 2)
      throw new RangeError("Invalid JSON for fold state");
    let e = [];
    for (let t = 0; t < n.length; ) {
      let r = n[t++], i = n[t++];
      if (typeof r != "number" || typeof i != "number")
        throw new RangeError("Invalid JSON for fold state");
      e.push(re.range(r, i));
    }
    return g.set(e, !0);
  }
});
function F(n, e, t) {
  var r;
  let i = null;
  return (r = n.field(x, !1)) === null || r === void 0 || r.between(e, t, (s, o) => {
    (!i || i.from > s) && (i = { from: s, to: o });
  }), i;
}
function nt(n, e, t) {
  let r = !1;
  return n.between(e, e, (i, s) => {
    i == e && s == t && (r = !0);
  }), r;
}
function ge(n, e) {
  return n.field(x, !1) ? e : e.concat(H.appendConfig.of(be()));
}
const rt = (n) => {
  for (let e of me(n)) {
    let t = E(n.state, e.from, e.to);
    if (t)
      return n.dispatch({ effects: ge(n.state, [L.of(t), ke(n, t)]) }), !0;
  }
  return !1;
}, it = (n) => {
  if (!n.state.field(x, !1))
    return !1;
  let e = [];
  for (let t of me(n)) {
    let r = F(n.state, t.from, t.to);
    r && e.push(B.of(r), ke(n, r, !1));
  }
  return e.length && n.dispatch({ effects: e }), e.length > 0;
};
function ke(n, e, t = !0) {
  let r = n.state.doc.lineAt(e.from).number, i = n.state.doc.lineAt(e.to).number;
  return b.announce.of(`${n.state.phrase(t ? "Folded lines" : "Unfolded lines")} ${r} ${n.state.phrase("to")} ${i}.`);
}
const ot = (n) => {
  let { state: e } = n, t = [];
  for (let r = 0; r < e.doc.length; ) {
    let i = n.lineBlockAt(r), s = E(e, i.from, i.to);
    s && t.push(L.of(s)), r = (s ? n.lineBlockAt(s.to) : i).to + 1;
  }
  return t.length && n.dispatch({ effects: ge(n.state, t) }), !!t.length;
}, st = (n) => {
  let e = n.state.field(x, !1);
  if (!e || !e.size)
    return !1;
  let t = [];
  return e.between(0, n.state.doc.length, (r, i) => {
    t.push(B.of({ from: r, to: i }));
  }), n.dispatch({ effects: t }), !0;
}, Lt = [
  { key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: rt },
  { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: it },
  { key: "Ctrl-Alt-[", run: ot },
  { key: "Ctrl-Alt-]", run: st }
], lt = {
  placeholderDOM: null,
  preparePlaceholder: null,
  placeholderText: "…"
}, _ = /* @__PURE__ */ w.define({
  combine(n) {
    return se(n, lt);
  }
});
function be(n) {
  let e = [x, ct];
  return n && e.push(_.of(n)), e;
}
function ye(n, e) {
  let { state: t } = n, r = t.facet(_), i = (o) => {
    let a = n.lineBlockAt(n.posAtDOM(o.target)), l = F(n.state, a.from, a.to);
    l && n.dispatch({ effects: B.of(l) }), o.preventDefault();
  };
  if (r.placeholderDOM)
    return r.placeholderDOM(n, i, e);
  let s = document.createElement("span");
  return s.textContent = r.placeholderText, s.setAttribute("aria-label", t.phrase("folded code")), s.title = t.phrase("unfold"), s.className = "cm-foldPlaceholder", s.onclick = i, s;
}
const re = /* @__PURE__ */ g.replace({ widget: /* @__PURE__ */ new class extends ae {
  toDOM(n) {
    return ye(n, null);
  }
}() });
class at extends ae {
  constructor(e) {
    super(), this.value = e;
  }
  eq(e) {
    return this.value == e.value;
  }
  toDOM(e) {
    return ye(e, this.value);
  }
}
const ft = {
  openText: "⌄",
  closedText: "›",
  markerDOM: null,
  domEventHandlers: {},
  foldingChanged: () => !1
};
class j extends Me {
  constructor(e, t) {
    super(), this.config = e, this.open = t;
  }
  eq(e) {
    return this.config == e.config && this.open == e.open;
  }
  toDOM(e) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    let t = document.createElement("span");
    return t.textContent = this.open ? this.config.openText : this.config.closedText, t.title = e.state.phrase(this.open ? "Fold line" : "Unfold line"), t;
  }
}
function Wt(n = {}) {
  let e = Object.assign(Object.assign({}, ft), n), t = new j(e, !0), r = new j(e, !1), i = Y.fromClass(class {
    constructor(o) {
      this.from = o.viewport.from, this.markers = this.buildMarkers(o);
    }
    update(o) {
      (o.docChanged || o.viewportChanged || o.startState.facet(v) != o.state.facet(v) || o.startState.field(x, !1) != o.state.field(x, !1) || k(o.startState) != k(o.state) || e.foldingChanged(o)) && (this.markers = this.buildMarkers(o.view));
    }
    buildMarkers(o) {
      let a = new le();
      for (let l of o.viewportLineBlocks) {
        let c = F(o.state, l.from, l.to) ? r : E(o.state, l.from, l.to) ? t : null;
        c && a.add(l.from, l.from, c);
      }
      return a.finish();
    }
  }), { domEventHandlers: s } = e;
  return [
    i,
    Be({
      class: "cm-foldGutter",
      markers(o) {
        var a;
        return ((a = o.plugin(i)) === null || a === void 0 ? void 0 : a.markers) || Pe.empty;
      },
      initialSpacer() {
        return new j(e, !1);
      },
      domEventHandlers: Object.assign(Object.assign({}, s), { click: (o, a, l) => {
        if (s.click && s.click(o, a, l))
          return !0;
        let c = F(o.state, a.from, a.to);
        if (c)
          return o.dispatch({ effects: B.of(c) }), !0;
        let f = E(o.state, a.from, a.to);
        return f ? (o.dispatch({ effects: L.of(f) }), !0) : !1;
      } })
    }),
    be()
  ];
}
const ct = /* @__PURE__ */ b.baseTheme({
  ".cm-foldPlaceholder": {
    backgroundColor: "#eee",
    border: "1px solid #ddd",
    color: "#888",
    borderRadius: ".2em",
    margin: "0 1px",
    padding: "0 1px",
    cursor: "pointer"
  },
  ".cm-foldGutter span": {
    padding: "0 1px",
    cursor: "pointer"
  }
});
class W {
  constructor(e, t) {
    this.specs = e;
    let r;
    function i(a) {
      let l = ee.newName();
      return (r || (r = /* @__PURE__ */ Object.create(null)))["." + l] = a, l;
    }
    const s = typeof t.all == "string" ? t.all : t.all ? i(t.all) : void 0, o = t.scope;
    this.scope = o instanceof m ? (a) => a.prop(T) == o.data : o ? (a) => a == o : void 0, this.style = Ee(e.map((a) => ({
      tag: a.tag,
      class: a.class || i(Object.assign({}, a, { tag: null }))
    })), {
      all: s
    }).style, this.module = r ? new ee(r) : null, this.themeType = t.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(e, t) {
    return new W(e, t || {});
  }
}
const J = /* @__PURE__ */ w.define(), we = /* @__PURE__ */ w.define({
  combine(n) {
    return n.length ? [n[0]] : null;
  }
});
function q(n) {
  let e = n.facet(J);
  return e.length ? e : n.facet(we);
}
function Ut(n, e) {
  let t = [ht], r;
  return n instanceof W && (n.module && t.push(b.styleModule.of(n.module)), r = n.themeType), e != null && e.fallback ? t.push(we.of(n)) : r ? t.push(J.computeN([b.darkTheme], (i) => i.facet(b.darkTheme) == (r == "dark") ? [n] : [])) : t.push(J.of(n)), t;
}
class ut {
  constructor(e) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = k(e.state), this.decorations = this.buildDeco(e, q(e.state));
  }
  update(e) {
    let t = k(e.state), r = q(e.state), i = r != q(e.startState);
    t.length < e.view.viewport.to && !i && t.type == this.tree.type ? this.decorations = this.decorations.map(e.changes) : (t != this.tree || e.viewportChanged || i) && (this.tree = t, this.decorations = this.buildDeco(e.view, r));
  }
  buildDeco(e, t) {
    if (!t || !this.tree.length)
      return g.none;
    let r = new le();
    for (let { from: i, to: s } of e.visibleRanges)
      Fe(this.tree, t, (o, a, l) => {
        r.add(o, a, this.markCache[l] || (this.markCache[l] = g.mark({ class: l })));
      }, i, s);
    return r.finish();
  }
}
const ht = /* @__PURE__ */ De.high(/* @__PURE__ */ Y.fromClass(ut, {
  decorations: (n) => n.decorations
})), Rt = /* @__PURE__ */ W.define([
  {
    tag: u.meta,
    color: "#404740"
  },
  {
    tag: u.link,
    textDecoration: "underline"
  },
  {
    tag: u.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: u.emphasis,
    fontStyle: "italic"
  },
  {
    tag: u.strong,
    fontWeight: "bold"
  },
  {
    tag: u.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: u.keyword,
    color: "#708"
  },
  {
    tag: [u.atom, u.bool, u.url, u.contentSeparator, u.labelName],
    color: "#219"
  },
  {
    tag: [u.literal, u.inserted],
    color: "#164"
  },
  {
    tag: [u.string, u.deleted],
    color: "#a11"
  },
  {
    tag: [u.regexp, u.escape, /* @__PURE__ */ u.special(u.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ u.definition(u.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ u.local(u.variableName),
    color: "#30a"
  },
  {
    tag: [u.typeName, u.namespace],
    color: "#085"
  },
  {
    tag: u.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ u.special(u.variableName), u.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ u.definition(u.propertyName),
    color: "#00c"
  },
  {
    tag: u.comment,
    color: "#940"
  },
  {
    tag: u.invalid,
    color: "#f00"
  }
]), dt = /* @__PURE__ */ b.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
}), ve = 1e4, xe = "()[]{}", Se = /* @__PURE__ */ w.define({
  combine(n) {
    return se(n, {
      afterCursor: !0,
      brackets: xe,
      maxScanDistance: ve,
      renderMatch: gt
    });
  }
}), pt = /* @__PURE__ */ g.mark({ class: "cm-matchingBracket" }), mt = /* @__PURE__ */ g.mark({ class: "cm-nonmatchingBracket" });
function gt(n) {
  let e = [], t = n.matched ? pt : mt;
  return e.push(t.range(n.start.from, n.start.to)), n.end && e.push(t.range(n.end.from, n.end.to)), e;
}
const kt = /* @__PURE__ */ X.define({
  create() {
    return g.none;
  },
  update(n, e) {
    if (!e.docChanged && !e.selection)
      return n;
    let t = [], r = e.state.facet(Se);
    for (let i of e.state.selection.ranges) {
      if (!i.empty)
        continue;
      let s = I(e.state, i.head, -1, r) || i.head > 0 && I(e.state, i.head - 1, 1, r) || r.afterCursor && (I(e.state, i.head, 1, r) || i.head < e.state.doc.length && I(e.state, i.head + 1, -1, r));
      s && (t = t.concat(r.renderMatch(s, e.state)));
    }
    return g.set(t, !0);
  },
  provide: (n) => b.decorations.from(n)
}), bt = [
  kt,
  dt
];
function $t(n = {}) {
  return [Se.of(n), bt];
}
const yt = /* @__PURE__ */ new y();
function V(n, e, t) {
  let r = n.prop(e < 0 ? y.openedBy : y.closedBy);
  if (r)
    return r;
  if (n.name.length == 1) {
    let i = t.indexOf(n.name);
    if (i > -1 && i % 2 == (e < 0 ? 1 : 0))
      return [t[i + e]];
  }
  return null;
}
function K(n) {
  let e = n.type.prop(yt);
  return e ? e(n.node) : n;
}
function I(n, e, t, r = {}) {
  let i = r.maxScanDistance || ve, s = r.brackets || xe, o = k(n), a = o.resolveInner(e, t);
  for (let l = a; l; l = l.parent) {
    let c = V(l.type, t, s);
    if (c && l.from < l.to) {
      let f = K(l);
      if (f && (t > 0 ? e >= f.from && e < f.to : e > f.from && e <= f.to))
        return wt(n, e, t, l, f, c, s);
    }
  }
  return vt(n, e, t, o, a.type, i, s);
}
function wt(n, e, t, r, i, s, o) {
  let a = r.parent, l = { from: i.from, to: i.to }, c = 0, f = a == null ? void 0 : a.cursor();
  if (f && (t < 0 ? f.childBefore(r.from) : f.childAfter(r.to)))
    do
      if (t < 0 ? f.to <= r.from : f.from >= r.to) {
        if (c == 0 && s.indexOf(f.type.name) > -1 && f.from < f.to) {
          let h = K(f);
          return { start: l, end: h ? { from: h.from, to: h.to } : void 0, matched: !0 };
        } else if (V(f.type, t, o))
          c++;
        else if (V(f.type, -t, o)) {
          if (c == 0) {
            let h = K(f);
            return {
              start: l,
              end: h && h.from < h.to ? { from: h.from, to: h.to } : void 0,
              matched: !1
            };
          }
          c--;
        }
      }
    while (t < 0 ? f.prevSibling() : f.nextSibling());
  return { start: l, matched: !1 };
}
function vt(n, e, t, r, i, s, o) {
  let a = t < 0 ? n.sliceDoc(e - 1, e) : n.sliceDoc(e, e + 1), l = o.indexOf(a);
  if (l < 0 || l % 2 == 0 != t > 0)
    return null;
  let c = { from: t < 0 ? e - 1 : e, to: t > 0 ? e + 1 : e }, f = n.doc.iterRange(e, t > 0 ? n.doc.length : 0), h = 0;
  for (let p = 0; !f.next().done && p <= s; ) {
    let d = f.value;
    t < 0 && (p += d.length);
    let S = e + p * t;
    for (let C = t > 0 ? 0 : d.length - 1, Ce = t > 0 ? d.length : -1; C != Ce; C += t) {
      let U = o.indexOf(d[C]);
      if (!(U < 0 || r.resolveInner(S + C, 1).type != i))
        if (U % 2 == 0 == t > 0)
          h++;
        else {
          if (h == 1)
            return { start: c, end: { from: S + C, to: S + C + 1 }, matched: U >> 1 == l >> 1 };
          h--;
        }
    }
    t > 0 && (p += d.length);
  }
  return f.done ? { start: c, matched: !1 } : null;
}
const xt = /* @__PURE__ */ Object.create(null), ie = [Q.none], oe = [], St = /* @__PURE__ */ Object.create(null);
for (let [n, e] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  St[n] = /* @__PURE__ */ Ct(xt, e);
function z(n, e) {
  oe.indexOf(n) > -1 || (oe.push(n), console.warn(e));
}
function Ct(n, e) {
  let t = [];
  for (let s of e.split(" ")) {
    let o = [];
    for (let a of s.split(".")) {
      let l = n[a] || u[a];
      l ? typeof l == "function" ? o.length ? o = o.map(l) : z(a, `Modifier ${a} used at start of tag`) : o.length ? z(a, `Tag ${a} used as modifier`) : o = Array.isArray(l) ? l : [l] : z(a, `Unknown highlighting tag ${a}`);
    }
    for (let a of o)
      t.push(a);
  }
  if (!t.length)
    return 0;
  let r = e.replace(/ /g, "_"), i = Q.define({
    id: ie.length,
    name: r,
    props: [Ne({ [r]: t })]
  });
  return ie.push(i), i.id;
}
export {
  We as DocInput,
  W as HighlightStyle,
  ue as IndentContext,
  G as LRLanguage,
  m as Language,
  It as LanguageSupport,
  N as ParseContext,
  Z as TreeIndentContext,
  $t as bracketMatching,
  yt as bracketMatchingHandle,
  be as codeFolding,
  Et as continuedIndent,
  Rt as defaultHighlightStyle,
  He as defineLanguageFacet,
  Mt as delimitedIndent,
  Nt as flatIndent,
  ot as foldAll,
  rt as foldCode,
  L as foldEffect,
  Wt as foldGutter,
  Ht as foldInside,
  Lt as foldKeymap,
  _e as foldNodeProp,
  Ze as foldService,
  x as foldState,
  E as foldable,
  $e as getIndentUnit,
  qe as getIndentation,
  ze as indentNodeProp,
  Ft as indentOnInput,
  Re as indentService,
  je as indentString,
  ce as indentUnit,
  v as language,
  T as languageDataProp,
  I as matchBrackets,
  Le as sublanguageProp,
  Ut as syntaxHighlighting,
  k as syntaxTree,
  st as unfoldAll,
  it as unfoldCode,
  B as unfoldEffect
};
